import { useDebounceFn, type DebounceOptions } from '@dni-react-hooks/use-debounce-fn'
import { useEffect, useState } from 'react'

export function useDebounceValue<T>(value: T, wait?: number, options?: DebounceOptions) {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const updateDebouncedValue = useDebounceFn(setDebouncedValue, wait, options)

  useEffect(() => {
    updateDebouncedValue(value)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return debouncedValue
}
